@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --bg:        #080b10;
  --surface:   #0f1318;
  --card:      #141920;
  --card2:     #1a2030;
  --border:    #1f2a38;
  --blue:      #3b82f6;
  --blue-glow: rgba(59,130,246,0.15);
  --teal:      #00c9a7;
  --teal-glow: rgba(0,201,167,0.12);
  --text:      #e2e8f4;
  --muted:     #64748b;
  --danger:    #ef4444;
  --warn:      #f59e0b;
  --success:   #22c55e;
  --head:      'Barlow Condensed', sans-serif;
  --body:      'DM Sans', sans-serif;
}

html, body, #root { height: 100%; }
body { background: var(--bg); color: var(--text); font-family: var(--body); -webkit-font-smoothing: antialiased; }
a { color: inherit; text-decoration: none; }

/* BUTTONS */
.btn-primary {
  background: var(--blue); color: #fff; border: none; border-radius: 10px;
  padding: 13px 28px; font-family: var(--body); font-size: 15px; font-weight: 600;
  cursor: pointer; transition: all .2s; box-shadow: 0 0 20px var(--blue-glow);
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
}
.btn-primary:hover   { background: #2563eb; transform: translateY(-1px); }
.btn-primary:disabled { opacity: .4; cursor: not-allowed; transform: none; }
.btn-primary.full    { width: 100%; }

.btn-secondary {
  background: transparent; color: var(--muted); border: 2px solid var(--border);
  border-radius: 10px; padding: 11px 24px; font-family: var(--body); font-size: 14px;
  font-weight: 500; cursor: pointer; transition: all .2s;
  display: inline-flex; align-items: center; gap: 8px;
}
.btn-secondary:hover { border-color: var(--blue); color: var(--text); }
.btn-ghost {
  background: transparent; border: none; color: var(--muted); font-family: var(--body);
  font-size: 14px; cursor: pointer; padding: 8px 12px; border-radius: 8px; transition: all .2s;
}
.btn-ghost:hover { color: var(--text); background: var(--card); }

/* FORMS */
.form-group { display: flex; flex-direction: column; gap: 6px; }
.form-group label { font-size: 12px; font-weight: 600; color: var(--muted); letter-spacing: 1px; text-transform: uppercase; }
.form-group input,
.form-group textarea,
.form-group select {
  background: var(--card); border: 2px solid var(--border); border-radius: 10px;
  padding: 12px 14px; color: var(--text); font-family: var(--body); font-size: 14px;
  outline: none; transition: border .2s; width: 100%;
}
.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus { border-color: var(--blue); }
.form-group textarea { resize: vertical; min-height: 80px; }

/* CARDS */
.panel { background: var(--card); border: 1px solid var(--border); border-radius: 16px; overflow: hidden; }
.panel-header { padding: 16px 20px; border-bottom: 1px solid var(--border); display: flex; align-items: center; justify-content: space-between; }
.panel-header h3 { font-family: var(--head); font-size: 18px; font-weight: 700; letter-spacing: 1px; }

/* BADGES */
.badge { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 11px; font-weight: 600; letter-spacing: .5px; }
.badge.confirmed  { background: rgba(34,197,94,.12);   color: var(--success); }
.badge.pending    { background: rgba(245,158,11,.12);  color: var(--warn); }
.badge.declined   { background: rgba(239,68,68,.12);   color: var(--danger); }
.badge.cancelled  { background: rgba(100,116,139,.12); color: var(--muted); }
.badge.free      { background: rgba(100,116,139,.12); color: var(--muted); }
.badge.pro       { background: rgba(59,130,246,.15);  color: var(--blue); }

/* SPINNER */
.spinner { width: 18px; height: 18px; border: 2px solid rgba(255,255,255,.25); border-top-color: #fff; border-radius: 50%; animation: spin .7s linear infinite; display: inline-block; flex-shrink: 0; }
@keyframes spin { to { transform: rotate(360deg); } }

/* TOAST */
.toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  background: var(--card2); border: 1px solid var(--border); border-radius: 12px;
  padding: 14px 24px; font-size: 14px; font-weight: 500; z-index: 999;
  box-shadow: 0 8px 32px rgba(0,0,0,.4); animation: slideUp .3s ease; white-space: nowrap;
}
.toast.success { border-color: var(--success); color: var(--success); }
.toast.error   { border-color: var(--danger);  color: var(--danger); }
@keyframes slideUp { from { transform: translateX(-50%) translateY(20px); opacity:0; } to { transform: translateX(-50%) translateY(0); opacity:1; } }

/* MODAL */
.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.75); display: flex; align-items: center; justify-content: center; z-index: 200; padding: 20px; }
.modal { background: var(--surface); border: 1px solid var(--border); border-radius: 18px; padding: 28px; max-width: 460px; width: 100%; max-height: 90vh; overflow-y: auto; }

/* ANIMATIONS */
@keyframes fadeIn { from { opacity:0; transform: translateY(8px); } to { opacity:1; transform: translateY(0); } }
.fade-in { animation: fadeIn .35s ease forwards; }
@keyframes pop { from { transform:scale(0); opacity:0; } to { transform:scale(1); opacity:1; } }
